import { Button } from "antd"
import React, { useId } from "react"
import { useTranslation } from "react-i18next"

import type { AutomationOptions } from "../types/automation.types"

interface TokenChipsProps {
  tokens: AutomationOptions["tokens"]
  onInsert: (token: string) => void
}

function TokenChips({ tokens, onInsert }: TokenChipsProps) {
  const { t } = useTranslation()
  const id = useId()
  const labelId = `${id}-label`
  const helpId = `${id}-help`
  return (
    <div>
      <p id={labelId} className={"m-0 mb-1 text-xs font-medium text-gray-600"}>
        {t("settingsAutomation.builder.tokens.label")}
      </p>
      <div role={"group"} aria-labelledby={labelId} aria-describedby={helpId} className={"flex flex-wrap gap-1"}>
        {tokens.map(({ key, token, label }) => (
          <Button
            key={key}
            size={"small"}
            aria-label={t("settingsAutomation.builder.tokens.insert", { label })}
            // Keep the editor's selection so the token lands at the cursor.
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onInsert(token)}
          >
            {token}
          </Button>
        ))}
      </div>
      <p id={helpId} className={"mt-1 mb-0 text-xs text-gray-600"}>
        {t("settingsAutomation.builder.tokens.help")}
      </p>
    </div>
  )
}

export { type TokenChipsProps, TokenChips }
